import StoredLayout from '../../layouts/StoredLayout'
import ECommerce from './ECommerce'
export default StoredLayout(ECommerce)
